import { PropTypes } from 'prop-types';
import * as R from 'ramda';
import React from 'react';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import FormControl from 'react-bootstrap/FormControl';
import FormGroup from 'react-bootstrap/FormGroup';

import FieldError from '../../components/field-error';
import Well from '../../components/well';
import { validate } from '../../utils/validation';

import { CERT_FIELDS, labCertsSchema } from './lab-certs-schema';

class LabCerts extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            ca_keys: '',
            ca_certs: '',
            tls_auth: '',
            errors: {},
            submitted: false,
        };
        this.handleTextFieldChange = R.bind(this.handleTextFieldChange, this);
        this.uploadCerts = R.bind(this.uploadCerts, this);
        this.validationValues = R.bind(this.validationValues, this);
        this.CertField = R.bind(this.CertField, this);
    }

    validationValues() {
        return R.mergeRight(
            R.pick(CERT_FIELDS, this.state),
            R.pick(['pfSense_format', 'pfSense_tls'], this.props.labReducer.currentLab),
        );
    }

    handleTextFieldChange({ target }) {
        this.setState({ [target.name]: target.value }, () => {
            if (this.state.submitted) {
                this.setState({ errors: validate(labCertsSchema, this.validationValues()).errors });
            }
        });
    }

    uploadCerts() {
        const { id } = this.props.labReducer.currentLab;

        const hasLabId = !R.isNil(id);

        const { valid, errors } = validate(labCertsSchema, this.validationValues());

        this.setState({ errors, submitted: true });

        if (valid && hasLabId) {
            this.props.uploadLabKeys(R.mergeRight({ id }, R.pick(CERT_FIELDS, this.state)));
        }
    }

    CertField(name, placeholder) {
        const error = this.state.errors[name];

        return (
            <FormGroup>
                <FormControl
                    as="textarea"
                    placeholder={placeholder}
                    onChange={this.handleTextFieldChange}
                    name={name}
                    rows="4"
                    isInvalid={!!error}
                    {...(error && { 'aria-invalid': 'true', 'aria-describedby': `${name}-error` })}
                />
                <FieldError id={`${name}-error`} error={error} />
            </FormGroup>
        );
    }

    render() {
        const {
            labReducer: { currentLab },
        } = this.props;

        return (
            <div>
                <Well>
                    <h2>{R.propOr('Loading...', 'name', currentLab)}</h2>
                    <h3>Upload Key/Cert</h3>
                </Well>
                <Card>
                    {this.CertField('ca_keys', 'CA Key')}
                    {this.CertField('ca_certs', 'CA Cert')}
                    {this.props.labReducer.currentLab.pfSense_format === 1 &&
                        this.props.labReducer.currentLab.pfSense_tls === 1 &&
                        this.CertField('tls_auth', 'TLS auth')}
                    <Button variant="success" onClick={this.uploadCerts}>
                        Upload Keys
                    </Button>
                </Card>
            </div>
        );
    }
}

LabCerts.propTypes = {
    labReducer: PropTypes.object,
    uploadLabKeys: PropTypes.func,
};

export default LabCerts;
